<template>
  <!-- mob -->
  <div v-if="isPortrait" class="threepage">
    <div class="title-container">
      <img src="/assets/~/media/images/activity/guangzhou/thirdpage-title-mob.png" alt="">
    </div>

    <div ref="slideCarousel" class="carousel-container" style="overflow: hidden;">
      <div class="swiper-wrapper">
        <div class="swiper-slide" style="height: 100%;" v-for="item in imgUrls" :key="item.index">
          <img style="opacity:1;width: 100%;"   :src="preText + item.urlmb">
        </div>
      </div>

    </div>
    <div class="swiper-pagination-kv2"></div>
    <div class="text-container">
      <img src="/assets/~/media/images/activity/guangzhou/thirdpage-text-mob.png" alt="">
    </div>

    <div class="btn-box" @click="learnMore" code-stm="event, PAGEURL, 了解详情">了解详情</div>
  </div>
  <!-- pc -->
  <div v-else class="threepage">
    <div class="text-container">
      <img src="/assets/~/media/images/activity/guangzhou/thirdpage-text-pc.png" alt="">
    </div>
    <div ref="slideCarousel" class="carousel-container" style="overflow: hidden;">
      <div class="swiper-wrapper">
        <div class="swiper-slide" style="height: 100%;" v-for="item in imgUrls" :key="item.index">
          <img style="opacity:1;width: 100%;height: 100%;" :src="preText + item.url">
        </div>
      </div>
    </div>
    <div class="swiper-pagination-kv2"></div>

      <div class="swiper-button-next" id="swiper-button-next" code-stm="event, PAGEURL, 第三屏轮播图下一页">
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="swiper-button-prev" id="swiper-button-prev" code-stm="event, PAGEURL, 第三屏轮播图上一页">
        <i class="el-icon-arrow-left"></i>
      </div>


    <div class="btn-box" @click="learnMore" code-stm="event, PAGEURL, 了解详情">了解详情</div>
  </div>
</template>

<script>
import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
import Swiper from "swiper";

export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      preText:'https://www.kia.cn',
      imgUrls: [
        {
          index: 0,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-1.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-1.png',
        },
        {
          index: 1,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-2.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-2.png',
        },
        {
          index: 2,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-3.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-3.png',
        },
        {
          index: 3,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-4.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-4.png',
        },
        {
          index: 4,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-5.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-5.png',
        },
        {
          index: 5,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-6.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-6.png',
        },
        {
          index: 6,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-7.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-7.png',
        },
        {
          index: 7,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-8.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-8.png',
        },
        {
          index: 8,
          url: '/assets/~/media/images/activity/guangzhou/carousel-pc-9.png',
          urlmb: '/assets/~/media/images/activity/guangzhou/carousel-mob-9.png',
        }
      ]
    }
  },
  computed: {
    isSafari() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return true
      } else {
        return false
      } //判断是否Safari浏览器
    }
  },
  watch: {

  },
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = 'https://uat.kia.cn'
    }else{
      this.preText = 'https://www.kia.cn'
    }
    // this.slideBanner()
    window.addEventListener("resize", this.setResize);

    this.$nextTick(()=>{
        this.swiper = new Swiper(".carousel-container", {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            // sliderPerview: 'auto',
            // loopAdditionalSlides: 5,
            loopFillGroupWithBlank: false,
            autoplayDisableOnInteraction : false,
            // autoplay: {
            //     delay: 5000,
            //      disableOnInteraction: false,
            // },
            pagination: {
              el: ".swiper-pagination-kv2",
            },
            navigation: {
              nextEl: "#swiper-button-next",
              prevEl: "#swiper-button-prev",
            },
            on: {
            slideChangeTransitionEnd: this.slideChangeTransitionEnd,
            },
        });
    })

  },
  destroyed() {
    window.removeEventListener("resize", this.setResize);
  },
  methods: {
    //了解更多
    learnMore(){
      window.open('https://www.kia.cn/brand/news/official-news/2023122901/2024111502/')
    },
    // 滑动切换
    slideBanner() {
      console.log("滑动切换");
      //选中的轮播图
      var box = document.querySelector('.el-carousel__container');
      box.onClick = (()=>{console.log("点击el-carousel");})
      var startPointX = 0
      var stopPointX = 0
      //重置坐标
      var resetPoint = function () {
        startPointX = 0
        stopPointX = 0
      }
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指点击位置的X坐标
        startPointX = e.changedTouches[0].pageX
      });
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPointX = e.changedTouches[0].pageX
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener("touchend", function (e) {
        if (stopPointX == 0 || startPointX - stopPointX == 0) {
          console.log("a");
          resetPoint()
          return
        }
        if (startPointX - stopPointX > 0) {
          resetPoint()
          that.$refs.slideCarousel.next()
          console.log("b");
          return
        }
        if (startPointX - stopPointX < 0) {
          resetPoint()
          that.$refs.slideCarousel.prev()
          console.log("c");
          return
        }
      });
    },
    toev5() {
      window.open('https://www.kia.cn/vehicles/ev6/')
    },

    slideChangeTransitionEnd() {
    //   this.playVideo(this.swiper?.activeIndex);
    //   this.pauseVideo(this.swiper?.previousIndex);
    },
    setResize() {
      this.isPortrait = isPortraitFun();
    },
  },
}
</script>
<style  lang="scss" scoped>
//pc start
@media (min-width: 767px) {
  .swiper-button-prev,.swiper-button-next {
    width: calc(52 / 1920 * 100vw);
    height: calc(52 / 1920 * 100vw);
    position: absolute;
    color: #697278;
    border: solid 1px #697278;
    border-radius: calc(55 / 1920 * 100vw);
  }
  .swiper-button-prev {
    top: calc(50% - 180 / 1920 * 100vw + 551 / 1920 * 100vw);
    left: calc(100vw - 305 / 1920 * 100vw);
  }
  .swiper-button-next {
    top: calc(50% - 180 / 1920 * 100vw + 551 / 1920 * 100vw);
    left: calc(100vw - 220 / 1920 * 100vw);
  }
  .swiper-button-next:after {
    content: none;
  }
  .swiper-button-prev:after {
    content: none;
  }
  ::v-deep .swiper-pagination-bullet {
    margin: calc(7 / 1920 * 100vw);
    background-color: transparent;
    border: solid 1px #475669;
    width: calc(11 / 1920 * 100vw);
    height: calc(11 / 1920 * 100vw);
  }
  ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
    // background-color: #ffffff;
    // background: rgba(0, 80, 255, 1);
    background-color: #000000;
    border-radius: 10px;
    width: calc(14 / 1920 * 100vw);
    height: calc(14 / 1920 * 100vw);
  }

  .swiper-pagination-kv2{
    position: absolute;
    top: calc(50% - 210 / 1920 * 100vw + 551 / 1920 * 100vw);
    left: calc(100% - 826 / 1920 * 100vw - 140 / 1920 * 100vw);
    width: calc(826 / 1920 * 100vw);
  }
  .swiper-pagination-bullets {
    width: calc(826 / 1920 * 100vw);
  }
.threepage {
  background: lightgrey;
  position: relative;
  height: calc(1080 / 1920 * 100vw);
  width: 100%;
  user-select: none;
}
.carousel-container {
  width: calc(826 / 1920 * 100vw);
  height: calc(551 / 1920 * 100vw);
  position: absolute;
  right: calc(140 / 1920 * 100vw);
  top: calc(50% - 239 / 1920 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  --swiper-navigation-size: 0;
}
.text-container {
  width: calc(492 / 1920 * 100vw);
  height: calc(382 / 1920 * 100vw);
  position: absolute;
  left: 0;
  top: calc(50% - 400 / 1920 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'zhonghei';
  letter-spacing: calc(2 / 1920 * 100vw);
  color: white;
  margin: 0 calc(30 / 1920 * 100vw) 0 calc(140 / 1920 * 100vw) ;
 img {
  width: calc(492 / 1920 * 100vw);
  height: calc(382 / 1920 * 100vw);
 }
  .first-title-box {
    padding:calc(4 / 1920 * 100vw) 0 calc(4 / 1920 * 100vw) calc(4 / 1920 * 100vw);
    border: solid 2px white;
    width: 90%;
    font-size: calc(40 / 1920 * 100vw);
    font-family: 'zhonghei';
    margin-bottom: calc(34 / 1920 * 100vw)
  }
  .first-title-en {
    font-size: calc(34 / 1920 * 100vw);
  }
  .divise-fat {
    border: solid 1px white;
    width: 90%;
  }
  .second-title-box {
    padding: calc(34 / 1920 * 100vw) 0;
    font-size: calc(24 / 1920 * 100vw);
  }

  .divise-thin {
    border-top: dashed 1px white;
    width: 95%;
  }
  .third-text {
    width: 95%;
    height: calc(250 / 1920 * 100vw);;
    font-size: calc(14 / 1920 * 100vw);
    line-height: calc(36 / 1920 * 100vw);
  }

}
.btn-box {
  width: calc(184 / 1920 * 100vw);
  height: calc(48 / 1920 * 100vw);
  position: absolute;
  border: solid 1px #000000;
  background-color: #000000;
  color: #ffffff;
  font-size: calc(16 / 1920 * 100vw);
  left:calc(160 / 1920 * 100vw);
  top: calc(50% - 400 / 1920 * 100vw + 382 / 1920 * 100vw + 58 / 1920 * 100vw );
  cursor: pointer;
  font-family: 'heijian';
  display: flex;
  justify-content: center;
  align-items: center;
}
}
//pc end
//mob strat
@media (max-width: 767px) {
  .swiper-pagination-kv2{

    // top: calc(50% - 210 / 1920 * 100vw + 551 / 1920 * 100vw);
    // left: calc(100% - 964 / 1920 * 100vw - 140 / 1920 * 100vw);
    width: 100%;
  }
  .swiper-pagination-bullets {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-top: calc(14 / 375 * 100vw);;
  }
  ::v-deep .swiper-pagination-bullet {
    margin: calc(7 / 375 * 100vw);
    background-color: transparent;
    border: solid 1px #475669;
    width: calc(10 / 375 * 100vw);
    height: calc(10 / 375 * 100vw);
  }
  ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #000000;
    border-radius: 10px;
    width: calc(12 / 375 * 100vw);
    height: calc(12 / 375 * 100vw);
  }
  .threepage {
  position: relative;
  width: 100%;
  user-select: none;
  padding-top: calc(50 / 375 * 100vw );
  padding-bottom: calc(50 / 375 * 100vw );
}
.title-container {
  width: calc(192 / 375 * 100vw);
  height: calc(38 / 375 * 100vw);
  margin: auto;
}
.carousel-container {
  width: calc(322 / 375 * 100vw);
  height: calc(214 / 375 * 100vw);
  margin: auto;
  margin-top: calc(30 / 375 * 100vw );
  // padding-bottom: calc(50 / 375 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // border-radius: calc(15 / 375 * 100vw);
}
.text-container {
  width: calc(285 / 375 * 100vw);
  height: calc(120 / 375 * 100vw);
  margin: calc(25 / 375 * 100vw ) auto;
  // padding-top: calc(20 / 375 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
    font-family: 'zhonghei';
  letter-spacing: calc(2 / 375 * 100vw);
  color: white;
  padding-bottom: calc(20 / 375 * 100vw);
  img {
    width: calc(285 / 375 * 100vw);
    height: calc(120 / 375 * 100vw);
 }
  .first-title-box {
    padding:calc(1 / 375 * 100vw) calc(6 / 375 * 100vw);
    border: solid 2px white;
    width: 75%;
    font-size: calc(20 / 375 * 100vw);
    font-family: 'Kia Signature';
    margin-bottom: calc(20 / 375 * 100vw);
    font-family: 'zhonghei';

  }
  .first-title-en {
    font-size: calc(16 / 375 * 100vw);
  }
  .divise-fat {
    display: none;
  }
  .second-title-box {
    padding: calc(20 / 375 * 100vw) 0;
    font-size: calc(14 / 375 * 100vw);
    font-family: 'zhonghei';

  }

  .divise-thin {
    border-top: dashed 1px white;
    width: 100%;
  }
  .third-text {
    // height: calc(80 / 375 * 100vw);
    font-size: calc(10 / 375 * 100vw);
    line-height: calc(35 / 375 * 100vw);
    font-family: 'zhonghei';
    padding-bottom: calc(10 / 375 * 100vw);

  }

}
.btn-box {
  width: calc(103 / 375 * 100vw);
  height: calc(40 / 375 * 100vw);
  border: solid 1px #000000;
  background-color: #000000;
  border-radius: 2px;
  color: white;
  padding: calc(2 / 375 * 100vw) calc(8 / 375 * 100vw);
  font-size: calc(13 / 375 * 100vw);
  margin: 0px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
}

@media screen and (orientation: portrait) {

  //隐藏掉鼠标悬浮出现的左右切换按钮
  ::v-deep .el-carousel__arrow {
    display: none;
  }
  .swiper-pagination-kv2{
    bottom: 20px!important;
  }

}

::v-deep .el-carousel__indicators {
  // display: none;
  bottom: 0;
}


//隐藏掉鼠标悬浮出现的左右切换按钮
// ::v-deep .el-carousel__arrow{
//   display: none;
// }
::v-deep .el-carousel__arrow {
  background-color: #ffffff;

  i {
    font-size: 30px;
  }
}

.el-carousel__arrow:hover {
  background-color: #475669;
}

::v-deep .el-carousel__container {
  position: relative;
  height: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #ffffff;
}

 .swiper {
      width: 100%;
      height: 400px;
    }

    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    // .swiper-slide img {
    //   display: block;
    //   width: 100%;
    //   height: 100%;
    //   object-fit: cover;
    // }
    // .swiper-pagination-kv2 {
    //   position: absolute;
    //   bottom: 70px;
    //   left: 0;
    //   width: 100%;
    //   text-align: center;
    //   z-index: 10;
    // }
</style>
